export const rubricRefinementSelectors = {
    refinementItems: state => state.rubricRefinement.refinementItems,
    refinementItemById: (state, id) => state.rubricRefinement.refinementItems.find(item => item.id === id),
    lastRefinementItem: state => {
        const items = state.rubricRefinement.refinementItems
        return items.length > 0 ? items[items.length - 1] : null
    },
    lastSubmissionItem: state => {
        const submissionItems = state.rubricRefinement.refinementItems.filter(item => item.type === 'Submission')
        return submissionItems?.at(-1)
    },
    refinementProcess: state => state.rubricRefinement.refinementProcess,
    refinementProgress: state => state.rubricRefinement.refinementProcess?.progress,
    hoveredCategoryId: state => state.rubricRefinement.hoveredCategoryId,
    hasStarted: state => state.rubricRefinement.hasStarted,
    hasApprovedSuggestions: state => {
        const { refinementItems } = state.rubricRefinement
        return refinementItems.some(item => 
            item.type === 'RubricSuggestion' && 
            item.diffReviewChoice === 'approved'
        )
    },
}
